<template>
  <div class="filter-button py-1 px-3" :class="filterButtonClass"
    @click="mouseClick" @mouseover="mouseOver" @mouseleave="mouseLeave">
      {{ $t('ctas.filter') }} <font-awesome-icon icon="filter" :class="filterIconClass" />
  </div>
</template>

<script>
const BUTTON_ON_CLASS = 'filter-on bg-primary text-white';
const BUTTON_OFF_CLASS = 'filter-off bg-primary-a1 text-primary';
const ICON_ON_CLASS = 'filter-icon-on text-white';
const ICON_OFF_CLASS = 'filter-icon-off text-primary';

export default {
  name: 'ToggleFilters',
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    cached: null,
    hover: false,
  }),
  computed: {
    filterButtonClass() {
      const value = this.cached === null ? this.value : this.cached;

      if (this.hover) {
        return value ? BUTTON_OFF_CLASS : BUTTON_ON_CLASS;
      } else {
        return value ? BUTTON_ON_CLASS : BUTTON_OFF_CLASS;
      }
    },
    filterIconClass() {
      const value = this.cached === null ? this.value : this.cached;

      if (this.hover) {
        return value ? ICON_OFF_CLASS : ICON_ON_CLASS;
      } else {
        return value ? ICON_ON_CLASS : ICON_OFF_CLASS;
      }
    },
  },
  methods: {
    mouseClick() {
      this.cached = this.value;
      this.$emit('input', !this.value);
    },
    mouseOver() {
      this.cached = this.value;
      this.hover = true;
    },
    mouseLeave() {
      this.cached = null;
      this.hover = false;
    },
  },
};
</script>

<style lang="scss">
.filter-button {
  font-size: 0.9rem;
  font-weight: bold;
  border-radius: 2px;
  cursor: pointer;

  .svg-inline--fa {
    margin-left: 3px;
    height:13px;
    width:13px;
  }

  &.filter-on, .filter-icon-on {
    color: #ffffff;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/misc/ToggleFilters.vue